<app-case-document-list-v3 *ngIf="case" [case]="case" [documentableType]="null"
                           [documentableId]="null">
</app-case-document-list-v3>
